import { ITableCol } from "@data/interfaces/itable.interface";

export const CUSTOMER_BILLING_COLUMNS: ITableCol[] = [
  { 
    type: 'text', 
    field: 'businessName', 
    header: 'Razón Social', 
    showFilter: true 
  },
  { 
    type: 'text', 
    field: 'contractNumber', 
    header: 'No. Contrato', 
    showFilter: true 
  },
  { 
    type: 'text', 
    field: 'paymentMethod', 
    header: 'Forma de Pago', 
    showFilter: true 
  },
  { 
    type: 'text', 
    field: 'paymentType', 
    header: 'Tipo de Pago', 
    showFilter: true 
  },
  { 
    type: 'text', 
    field: 'cfdiUsage', 
    header: 'Uso CFDI', 
    showFilter: true 
  },
  { 
    type: 'boolean', 
    field: 'isActive', 
    header: 'Activo', 
    showFilter: true,
    dataType: 'boolean' 
  },
  { 
    type: 'date', 
    field: 'createdAt', 
    header: 'Creado', 
    showFilter: true,
    dataType: 'date' 
  }
];

export const CUSTOMER_BILLING_ACTIONS = [
  { 
    title: 'Editar', 
    icon: 'fa-solid fa-edit', 
    action: 'EDIT',
    color: 'primary',
    permission: ['billing', 'update'] as [string, string]
  },
  { 
    title: 'Activar/Desactivar', 
    icon: 'fa-solid fa-toggle-on', 
    action: 'TOGGLE',
    color: 'warning',
    permission: ['billing', 'update'] as [string, string]
  },
  { 
    title: 'Ver Detalles', 
    icon: 'fa-solid fa-eye', 
    action: 'VIEW',
    color: 'info',
    permission: ['billing', 'get-by-id'] as [string, string]
  }
];